module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av530-938a8930814046d7a21d931de3fe6023.jpg";